import { render, staticRenderFns } from "./m-block-add-organization-manually.vue?vue&type=template&id=fc4501c4&scoped=true&lang=pug&"
import script from "./m-block-add-organization-manually.vue?vue&type=script&lang=js&"
export * from "./m-block-add-organization-manually.vue?vue&type=script&lang=js&"
import style0 from "./m-block-add-organization-manually.vue?vue&type=style&index=0&id=fc4501c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4501c4",
  null
  
)

export default component.exports